import type { DiffLine } from '../skillEditView';

const diffColor = { added: '#389e0d', removed: '#cf1322', same: 'inherit' };

/** A line diff: + added, - removed, the rest as context. Text renders escaped. */
const SkillDiff = ({ lines }: { lines: DiffLine[] }) => (
  <pre
    style={{
      maxHeight: 280,
      overflow: 'auto',
      fontSize: 12,
      margin: '0 0 12px',
    }}
  >
    {lines.map((l, i) => (
      <div
        key={i}
        style={{
          color: diffColor[l.kind],
          background:
            l.kind === 'added'
              ? 'rgba(56,158,13,0.1)'
              : l.kind === 'removed'
                ? 'rgba(207,19,34,0.1)'
                : undefined,
        }}
      >
        {l.kind === 'added' ? '+ ' : l.kind === 'removed' ? '- ' : '  '}
        {l.text}
      </div>
    ))}
  </pre>
);

export default SkillDiff;
